import { render, staticRenderFns } from "./LayoutAlternative.vue?vue&type=template&id=e50abb3a&"
import script from "./LayoutAlternative.vue?vue&type=script&lang=js&"
export * from "./LayoutAlternative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports